<template>
  <div>
    <el-container>
      <el-header class="other-list-header">
       <div style="text-align:center;">
          <span>查询条件：</span>
          <el-input
            style="width:45%; margin:20px auto;"
            placeholder="请输入关键字"
            v-model="searchText"
            size="mini"
          ></el-input>
          <el-button type="primary" size="mini" @click="listSearch()">查询</el-button>
        </div>
      </el-header>
      <el-container>
        <el-main class="other-list-main" style="height:100%">
          <el-table :data="listData" border style="width: 100%">
            <el-table-column type="expand">
            <template slot-scope="scope">
              <el-table :data="scope.row.lstUser">
                <el-table-column label="姓名" prop="Name"></el-table-column>
                <el-table-column label="性别">
                <template slot-scope="scope1">
                  {{scope1.row.Sex===1?'男':'女'}}
                </template>
                </el-table-column>
                <el-table-column label="手机" prop="Mobile"></el-table-column>
                <el-table-column label="操作" width="80" v-if="false">
               <template slot-scope="scope1">
                <el-button-group>
                  <el-button size="mini" type="danger" @click="listDelete(scope1.row)">删除</el-button>
                </el-button-group>
              </template>
            </el-table-column>
              </el-table>
            </template>
            </el-table-column>
            <el-table-column label="部门">
              <template slot-scope="scope">
                <span>{{ scope.row.Name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="电话">
              <template slot-scope="scope">
                <span>{{scope.row.Phone}}</span>
              </template>
            </el-table-column>
            
          </el-table>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import publish_ from "@/components/publish"; //引用模块进来
import { getNbtxlWorksListData, delNbtxlWorksModelMothod } from "@/api/api";

export default {
  data() {
    return {
     
      user: {},
      listData: {}, //列表集合数据
      searchText: "" //查询内容
    };
  },
  //初始化数据
  mounted() {
   
    this.user = JSON.parse(window.localStorage.user);
    this.getListData();
  },
  methods: {
    //查询列表
    getListData() {
      var _this = this;
      var para = {
        params: {
          companyId: this.user.companyId,
          name:this.searchText
        }
      };
      getNbtxlWorksListData(para).then(res => {
       var obj = JSON.parse(res.data);
        if (obj.Success) {
          _this.listData = obj.Data;
        
        } else {
          this.$message.error(obj.Message);
        }
      });
    },
    //点击查询
    listSearch() {
    
      this.getListData();
    },
    //list点击删除
    listDelete(row) {
   
      var para = {
        params: { deptId: row.Id }
      };
      delNbtxlWorksModelMothod(para).then(res => {
        if (res.data.success) {
          this.$message.success("删除成功");
          this.getListData();
        } else {
          this.$message.error(res.data.message);
        }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/fksys/nbtxl/works.vue